<script lang="ts">
	export let value = '';
	export let label = '';
	export let name = '';
	export let loading = false;
	export let message: string | void = '';
	export let messages: string[] = [];
	export let onInput = (name: string) => {};
	export let onChange = (name: string) => {};
	export let onFocus = (e: Event) => {};
	export let onBlur = (e: Event) => {};
  export let validityClass: string | 'error' | 'success' | 'warning' = '';



	const reactToInput = () => {
		// console.log(value)
    onInput(name);
		if (validityClass === 'error') onChange(name); // only needed for change
  }
</script>

<label class="label-xl book {validityClass}" class:load={loading || validityClass.indexOf('pending') > -1}>
	<textarea bind:value placeholder=" " {...$$props} on:change={() => onChange(name)} on:input={reactToInput} on:focus={onFocus} on:blur={onBlur} />
	<span>{label}{#if message || messages.length}<i>&nbsp;&#183; {message ?? messages[0]}</i>{/if}</span>
	{#if loading || validityClass.indexOf('pending') > -1}
		<span class="spinner"></span>
	{:else}
		<slot />
	{/if}
</label>

<style lang="scss">
  @use 'color';
  @use 'ease';

	textarea {
		min-height: 150px;
		max-height: 1000px;
		resize: vertical;
	}

	.error {
    color: color.$error;
    
    textarea {
      border-color: color.$error;
      &:not([type="checkbox"]):not([type="radio"]):not([type="range"]):not([type="file"]):focus {
        border-color: color.$error;
      }
    }
  }
	.load textarea {
		animation: load 800ms ease.$in-out-quart infinite;
	}

	.spinner {
		position: absolute;
		right: 54px;
		top: 50%;
		transform: translateY(-50%);
	}

	@keyframes load {
		from { border-color: color.$on-background-high-importance; }
		to { border-color: color.$on-background-medium-importance; }
	}
</style>